import { hexFromArgb, MaterialDynamicColors, } from '@material/material-color-utilities';
export const getMaterialDynamicColor = (token) => {
    return MaterialDynamicColors[token];
};
export const getMaterialDynamicSchemeColor = (token, scheme) => {
    const dynamicColor = getMaterialDynamicColor(token);
    const argbColor = dynamicColor.getArgb(scheme);
    const hexColor = hexFromArgb(argbColor);
    return hexColor;
};
